<template>
  <div class="MultilinkSlide">
    <SlideHeading v-bind="{ content }" />
    <div class="items">
      <MultilinkItem v-for="item in content.links"
        :key="item._key"
        :title="item.title"
        :cta="item.cta"
      />
    </div>
  </div>
</template>

<script>
import MultilinkItem from './elems/MultilinkItem.vue'
import SlideHeading from './elems/SlideHeading.vue'

export default {
  components: {
    MultilinkItem,
    SlideHeading,
  },
  props: {
    content: Object,
    isCurrentSlide: Boolean,
    selectedOptions: Object,
    fieldConfig: Object,
    fieldValues: Object,
    fieldErrors: Object,
  },
}
</script>

<style scoped>
.items {
  margin-top: var(--spacing-8);
  display: flex;
  flex-direction: column;
  row-gap: var(--spacing-5);
  max-width: var(--narrow-child-width);
}
</style>
